import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { SprinklerSystemInstallation } from '@authority-labs/api-interfaces';
import { MeasureType } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-sprinkler-system-installation-inspection',
  templateUrl: './sprinkler-system-installation-inspection.component.html',
  styleUrls: ['./sprinkler-system-installation-inspection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SprinklerSystemInstallationInspectionComponent {
  @Input() data: SprinklerSystemInstallation;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  plumberRoomWaterSupplyCharacteristics: MeasureType[] = [
    MeasureType.StaticPressure,
    MeasureType.ResidualPressure,
    MeasureType.FlowRate
  ];
  poolingVolumeCharacteristics: MeasureType[] = [MeasureType.PoolingVolume];

  onDataChange(): void {
    this.dataChange.emit();
  }
}
